import { Link } from "react-router-dom";
import { categories, siteName, siteSlogan } from "@/mocks/news";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-xl">
                <i className="ri-fire-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading font-black text-lg text-background-50">{siteName}</span>
                <span className="text-[10px] text-background-300 tracking-widest mt-0.5">{siteSlogan}</span>
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              追踪刚刚发生的热门事件，汇总热点最新动态，持续更新不遗漏。想第一时间吃透今日瓜料，点开这里就能看到新鲜出炉的爆料内容。
            </p>
          </div>

          <nav aria-label="内容频道">
            <h4 className="font-heading font-bold text-background-50 mb-4">内容频道</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="关于本站">
            <h4 className="font-heading font-bold text-background-50 mb-4">关于本站</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/contact#submit" className="text-sm text-background-300 hover:text-accent-400 transition-colors">
                  爆料投递
                </Link>
              </li>
            </ul>
          </nav>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4">联络我们</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <a href="mailto:tip@feidian-kuaixun.example" className="hover:text-accent-400 transition-colors">
                  tip@feidian-kuaixun.example
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5">
                  <i className="ri-time-line"></i>
                </span>
                线索接收：全天 24 小时
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400 mt-0.5">
                  <i className="ri-shield-check-line"></i>
                </span>
                涉及隐私的线索将做脱敏处理
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-6 py-5 border-t border-background-50/10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {year} {siteName} · 内容为公开信息整理，仅供阅读参考</p>
          <p>本站为内容聚合平台，不鼓励传播未经核实的信息</p>
        </div>
      </div>
    </footer>
  );
}